jQuery3_4_1(document).ready(function($){
    class Boligcard {
        constructor(parent) {
            const self = this;
            if(parent.boligcard){
                return;
            }
            parent.boligcard = self;
            self.console = new DD_Console();
            self.parent = $(parent);
            self.awake();
            setTimeout(function(){
                self.start();
            },0);
        }

        awake(){
            const self = this;
            self.console.verbose("AWAKE: Boligcard", self);
            self.registerSplide();
        }

        start(){
            const self = this;
            self.console.verbose("START: Boligcard", self);
            self.registerSplidePaginationButtons()
        }

        registerSplide(){
            const self = this;
			self.parent.find(".splide:not(.is-initialized)").each(function(index, element){
				element.splide = new Splide(element , {
					type   		: 'slide',
                    arrows      : false,
					pagination	: true,
					perMove     : 1,
					perPage     : 1,
				}).mount();
			})
        }

        registerSplidePaginationButtons(){
            const self = this;
            self.parent.find(".splide__pagination__page").on("click", function(event){
                if(event.originalEvent.pointerType == 'mouse'){
                    event.stopPropagation();
                }
            })
        }
    }
    registerOnLoadEvent(function(){
        $(".dd-boligcard").each(function(){
            new Boligcard(this);
        })
    });

});